import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "5c936b90-7373-4aa2-b4f1-417ca238b65c",
    options: { imageUrl: `${config.ASSETS_URL}/05/20/task/task-1-item-1.svg` },
  },
  {
    id: "298c7b9f-77b3-4f90-ad5f-3766a29e844c",
    options: { imageUrl: `${config.ASSETS_URL}/05/20/task/task-1-item-2.svg` },
  },
  {
    id: "d4390901-3540-43dd-bf2f-836dd5893309",
    options: { imageUrl: `${config.ASSETS_URL}/05/20/task/task-1-item-3.svg` },
  },
];

export const task: Task = {
  id: "9f836ddf-cdda-4141-84ec-a24c3a110ad0",
  solutionType: "order",
  type: "orderImages",
  options: {
    shuffle: true,
    imageViewType: "contain",
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "298c7b9f-77b3-4f90-ad5f-3766a29e844c",
    "5c936b90-7373-4aa2-b4f1-417ca238b65c",
    "d4390901-3540-43dd-bf2f-836dd5893309",
  ],
};
